import { NgModule } from '@angular/core';

import { MaterialModule } from '../../modules/material.module';
import { SharedModule } from '../../modules/shared.module';
import { PlanItemComponent } from './plan-item.component';

@NgModule({
  imports: [
    SharedModule,
    MaterialModule
  ],
  declarations: [
    PlanItemComponent
  ],
  exports: [
    PlanItemComponent
  ]
})
export class PlanItemModule {}
